<a class="back button" *ngIf="backLink && !isWebView" [routerLink]="backLink">
  <mat-icon>chevron_left</mat-icon>
  Zur Übersicht
</a>
<div  *ngIf="loading" class="spinner-container {{colorScheme.main}}">
  <mat-spinner strokeWidth="2" color="accent" diameter="54" class="m-auto"></mat-spinner>
</div>
<div *ngIf="!loading" class="content-container">
  <div class="card-list" #cardList>
    <ng-container *ngFor="let news of news; let i = index">
      <lib-news-card
        class="news-card rise-on-hover"
        aspectRatio="16/9"
        [news]="news"
        [layout]="layout">
      </lib-news-card>
      <lib-ad *ngIf="showAd(i)" class="ad"></lib-ad>
    </ng-container>
    <ng-container *ngFor="let match of matches; let i = index">
      <lib-match-card
        class="match-card rise-on-hover"
        [match]="match"
        [layout]="layout"
        [showContent]="false"
        [showStatusBadge]="videoType !== VideoContentType.LiveStreams">>
      </lib-match-card>
      <lib-ad *ngIf="showAd(i)" class="ad"></lib-ad>
    </ng-container>
  </div>
  <div
    *ngIf="moreContent"
    class="button"
    (click)="onMoreClick()"
  >
    <span>{{moreButtonTitle}}</span>
    <mat-icon>arrow_downward</mat-icon>
  </div>
  <span class="placeholder" *ngIf="placeholderText"> {{placeholderText}} </span>
</div>
